module.exports = __webpack_public_path__ + "img/IMG_8921.b6ca710c.jpg";